<template>
    <div class="income-chart-container">
      <div ref="chart" style="width: 100%; height: 400px;"></div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  
  export default {
    name: 'IncomeChart',
    props: {
      chartData: {
        type: Object,
        required: true,
        default: () => ({
          animation: false,
          tooltip: { trigger: 'axis' },
          legend: { data: ['收入'] },
          xAxis: { type: 'category', data: [] },
          yAxis: { type: 'value' },
          series: [
            { name: '收入', type: 'bar', data: [], itemStyle: { color: '#60A5FA' } },
            { name: '利润', type: 'bar', data: [], itemStyle: { color: '#34D399' } }
          ]
        })
      }
    },
    data() {
      return {
        chartInstance: null
      };
    },
    mounted() {
      this.initChart();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
    },
    watch: {
      chartData: {
        deep: true,
        handler(newVal) {
          if (this.chartInstance) {
            this.updateChart(newVal);
          } else {
            this.initChart();
          }
        }
      }
    },
    methods: {
      initChart() {
        if (!this.$refs.chart) return;
        
        this.chartInstance = echarts.init(this.$refs.chart);
        this.updateChart(this.chartData);
      },
      updateChart(data) {
        if (!this.chartInstance) return;
        
        const option = {
          animation: data.animation,
          tooltip: data.tooltip,
          legend: data.legend,
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: data.xAxis,
          yAxis: data.yAxis,
          series: data.series.map(series => ({
            ...series,
            barWidth: '60%',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}'
            }
          }))
        };
        
        this.chartInstance.setOption(option, true);
        this.handleResize();
      },
      handleResize() {
        if (this.chartInstance) {
          this.chartInstance.resize();
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .income-chart-container {
    width: 100%;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  </style>


// WEBPACK FOOTER //
// src/views/statistics/financial_statements/aa.vue